/** Dexcom G7–style cadence; matches gateway dexcom-poll scheduling (~5.5m). */
export const DEXCOM_GAP_MS = 330000;

export function getGlucoseColorClass(bg?: number): 'bg-gray' | 'bg-red' | 'bg-green' | 'bg-orange' {
  if (bg == null) return 'bg-gray';
  if (bg < 70) return 'bg-red';
  if (bg <= 140) return 'bg-green';
  return 'bg-orange';
}

export function getTrendArrow(trend?: string): string {
  if (!trend) return '→';
  switch (trend.toLowerCase()) {
    case 'flat':
      return '→';
    case 'fortyfiveup':
      return '↗';
    case 'singleup':
      return '↑';
    case 'doubleup':
      return '⇈';
    case 'fortyfivedown':
      return '↘';
    case 'singledown':
      return '↓';
    case 'doubledown':
      return '⇊';
    default:
      return '→';
  }
}

export function formatTimeAgo(nowMs: number, isoString?: string): string {
  if (!isoString) return '--';
  const elapsed = Math.round((nowMs - new Date(isoString).getTime()) / 1000);
  if (elapsed < 60) return `${elapsed}s ago`;
  if (elapsed < 3600) return `${Math.floor(elapsed / 60)}m ago`;
  if (elapsed < 86400) return `${Math.floor(elapsed / 3600)}h ago`;
  return `${Math.floor(elapsed / 86400)}d ago`;
}

export function formatNextDue(nowMs: number, isoString?: string): string {
  if (!isoString) return '--';
  const readingTime = new Date(isoString).getTime();
  const nextReadingTime = readingTime + DEXCOM_GAP_MS;
  const timeTillNext = Math.round((nextReadingTime - nowMs) / 1000);
  if (timeTillNext <= 0) {
    const overdue = Math.abs(timeTillNext);
    if (overdue < 60) return 'Due now';
    if (overdue < 300) return `${Math.floor(overdue / 60)}m ${overdue % 60}s overdue`;
    return `${Math.floor(overdue / 60)}m overdue`;
  }
  if (timeTillNext < 60) return `Due in ${timeTillNext}s`;
  if (timeTillNext < 300) return `Due in ${Math.floor(timeTillNext / 60)}m ${timeTillNext % 60}s`;
  return `Due in ${Math.floor(timeTillNext / 60)}m`;
}

/** A reading older than this is STALE: shown grey and struck through everywhere
 *  (dashboard, notebook, widget, Siri). Two missed Dexcom intervals — matches Dexcom Follow's own "---". */
export const STALE_AFTER_MS = 10 * 60 * 1000;

export function isReadingStale(now: number, timestamp?: string | null): boolean {
  if (!timestamp) return true;
  const t = new Date(timestamp).getTime();
  return !Number.isFinite(t) || now - t > STALE_AFTER_MS;
}
